export const CAREERS_LINK = 'https://special.breezy.hr/';
